import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {UserStore} from 'journey-store';
import {ContentStore} from 'journey-store';
import { LanguagesService } from '0-app-desktop/modules/user/languages/languages-service';

import { getCurrentUser, fetchAuthSession } from '@aws-amplify/auth';

@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit{
    
    private store = inject(UserStore);
    private contentStore = inject(ContentStore);
    private langServices = inject(LanguagesService);

    async ngOnInit() {
        const isLoading = this.contentStore.isLoading();
        console.log(`Isloading => `,isLoading);
        const userLoaded = await this.store.loadUser();
        
        console.log('Current user',this.store.profile());

        this.langServices.init();
        await this.printToken();
    }
    
    async printToken(): Promise<void> {
        try {
            const session = await fetchAuthSession();
            const idToken = session.tokens?.idToken?.toString();
            console.log('ID Token:', idToken);
            if (idToken) {
              // await navigator.clipboard.writeText(idToken);
              // console.log('✅ ID Token copied to clipboard!');
            } else {
              console.warn('⚠️ No ID token found in session.');
            }
          } catch (error) {
            console.error('❌ Failed to fetch or copy token:', error);
          }
      }
    }
